import { http } from '../../libs/react-mpk/services'

export const getSummary = () => (
  http.get(`/dashboard/summary`)
)

export const getChart = () => (
  http.get(`/dashboard/chart`)
)